// Course-tyyppiä ei tarvita, koska tämä palvelu palauttaa raakamuotoista dataa

// Layout info interface for cleaner typing
export interface LayoutInfo {
  id: string;
  name: string;
  holeCount: number | null;
  endDate?: string | null;
}

// Metrix API asetukset
const METRIX_CODE = 'zuSpEKSr6YSLYJG19fHmu6Xr4lWz2xuC';
const METRIX_API_BASE = 'https://discgolfmetrix.com/api.php';

/**
 * Service to fetch detailed course information directly from Metrix API
 * This helps avoid heavy processing in Cloud Functions
 */
export class MetrixCourseDetailService {
  private static instance: MetrixCourseDetailService;

  private constructor() {}

  public static getInstance(): MetrixCourseDetailService {
    if (!MetrixCourseDetailService.instance) {
      MetrixCourseDetailService.instance = new MetrixCourseDetailService();
    }
    return MetrixCourseDetailService.instance;
  }

  /**
   * Hakee yhden radan väylien määrän Metrix-API:sta
   * @param courseId Kurssin ID Metrixissä
   * @returns Promise joka palauttaa väylien määrän tai null virhetilanteessa
   */
  public async fetchCourseHoleCount(courseId: string): Promise<number | null> {
    // Removed console.log for cleaner debugging
    
    try {
      // Tarkistetaan välimuisti (ei käytössä tällä hetkellä - väliaikaisesti poistettu käytöstä)
      // Välimuistilla voisi optimoida API-kutsuja, mutta nyt haluamme varmistaa, että haut toimivat
      const cacheKey = `course_holes_${courseId}`;
      localStorage.removeItem(cacheKey); // Varmistetaan että välimuistissa ei ole mitään
      
      // Standard API call for all layouts
      const url = `${METRIX_API_BASE}?content=course&id=${courseId}&code=${METRIX_CODE}`;

      // Käytetään yksinkertaista fetch-kutsua ilman muokattuja otsikoita CORS-virheiden välttämiseksi
      // CORS-virhe: "Request header field expires is not allowed by Access-Control-Allow-Headers"
      const response = await fetch(url, {
        cache: 'no-store' // Estetään selaimen välimuistin käyttö
      });

      if (!response.ok) {
        return null;
      }
      
      const data = await response.json();
      
      // Validate data and extract hole count
      if (!data) {
        return null;
      }
      
      if (!data.baskets || !Array.isArray(data.baskets)) {
        return 0; // Palautetaan 0 kun väylien määrää ei löydy (parempi kuin null)
      }
      
      return data.baskets.length;
    } catch (error) {
      return 0; // Palautetaan 0 kun tapahtuu virhe (parempi kuin null UI:n päivitykseen)
    }
  }
}
